import React from "react";
import { DashboardLayout } from "../../../components/layouts/DashboardLayout";
import { Title, Text, Card, Stack, Box } from "@mantine/core";
import { PageProps } from "@sdflc/react-router-pages";

export const RoomTypesPage: React.FC<PageProps> = (props: PageProps) => {
  return (
    <DashboardLayout {...props}>
      <Box>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Stack gap="md" align="center" ta="center">
            <Title order={2} c="blue.6">
              Hello!
            </Title>
            <Text size="lg" c="dimmed">
              Welcome to VenueBoards
            </Text>
            <Text size="md">
              Your dashboard is ready. Start managing your venues, events, and
              bookings from here.
            </Text>
          </Stack>
        </Card>
      </Box>
    </DashboardLayout>
  );
};
